<template>
  <div>
    <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{ padding: 10 }">
      <template #title>
        <a-row type="flex" align="middle">
          <a-col :span="24" :md="12">
            <h5 class="font-semibold m-0">Activity Data</h5>
          </a-col>
          <a-col :span="24" :md="12" style="
                        display: flex;
                        align-items: center;
                        justify-content: flex-end
                      ">
          </a-col>
        </a-row>

        <a-row type="flex" align="middle" style="margin-top: 20px">
          <a-col :span="10">
            <a-input-search style="margin-left: 0px" placeholder="input search text" enter-button
              v-model="formSearch.searchText" @search="onSearchData" />
          </a-col> <a-col :span="14" align="right">
            <a-button type="primary" :disabled="loadBtnExport" class="mr-5 bg-success"
              @click="onShowModal('exportActivityData')">
              <a-icon v-if="!loadBtnExport" type="file-excel" theme="outlined" /><a-spin v-else /> Exports
            </a-button>
            <a-button type="primary" @click="toCreateData">
              + Add new activity
            </a-button>
          </a-col>
        </a-row>
      </template>

      <a-row class="mt-10 mb-10">
        <a-col :span="12" style="text-align: left">
          <a-tag color="blue">
            <p class="text-center mt-5 mb-0 font-bold">
              Total
              <span class="text-danger"> {{ countObjData }}</span>
              record
            </p>
          </a-tag>
        </a-col>
        <a-col :span="12" style="text-align: right">
          <a-pagination :current="currentPage" :total="countObjData" @change="onChangePage" :defaultPageSize="perPage" />
        </a-col>
      </a-row>
      <a-table :columns="columns" :data-source="data" :pagination="false" :loading="loading" size="small" bordered
        :scroll="{ x: 1500 }">
        <template slot="Item" slot-scope="text, record">
          <a-list size="small" bordered :data-source="record.item_detail">
            <a-list-item slot="renderItem" slot-scope="item, index">
              {{ item.by_type }} , {{ item.item_detail }}
            </a-list-item>
          </a-list>
        </template>
        <template slot="Action" slot-scope="text, record">
          <a-button type="" icon="edit" size="small" @click="onModalEdit(record)" />
        </template>
      </a-table>
      <a-row class="mt-10 mb-10">
        <a-col style="text-align: right">
          <a-pagination :current="currentPage" :total="countObjData" @change="onChangePage" :defaultPageSize="perPage" />
        </a-col>
      </a-row>
    </a-card>

    <!-- modal update  on-ok="handleOk"  -->
    <a-modal :width="750" v-model="visibleEdit" title="Edit Activity">
      <template slot="footer">
        <a-button key="back" @click="onModalEdit({})"> Close pop-up </a-button>
        <a-button key="submit" type="primary" :disabled="loadingEdit" :loading="loadingEdit"
          @click="onChangeDataActivity">
          Update Activity
        </a-button>
      </template>
      <!-- <pre>{{ formEdit }}</pre> -->
      <a-row>
        <a-col :span="6">
          <p class="text-center mt-5 mb-0 font-bold">
            Date of activity <span class="text-danger">*</span>
          </p>
        </a-col>
        <a-col :span="12">
          <a-date-picker format="YYYY-MM-DD" v-model="formEdit.date_of_activity" />
        </a-col>
      </a-row>
      <a-row class="mt-10 mb-10">
        <a-col :span="6">
          <p class="text-center mt-5 mb-0 font-bold">
            Activity Name <span class="text-danger">*</span>
          </p>
        </a-col>
        <a-col :span="12">
          <a-input v-model="formEdit.name_of_activity" />
        </a-col>
      </a-row>
      <a-row class="mt-10 mb-10">
        <a-col :span="6">
          <p class="text-center mt-5 mb-0 font-bold">
            Organized by <span class="text-danger">*</span>
          </p>
        </a-col>
        <a-col :span="12">
          <a-input v-model="formEdit.organized_by" />
        </a-col>
      </a-row>
      <a-row class="mt-10 mb-10">
        <a-col :span="6">
          <p class="text-center mt-5 mb-0 font-bold">
            Location <span class="text-danger">*</span>
          </p>
        </a-col>
        <a-col :span="12">
          <a-textarea placeholder="" :rows="5" v-model="formEdit.location" />
        </a-col>
      </a-row>
      <a-row class="mt-10 mb-10">
        <a-col :span="6">
          <p class="text-center mt-5 mb-0 font-bold">
            Activity expenses <span class="text-danger"></span>
          </p>
        </a-col>
        <a-col :span="12">
          <a-radio-group v-model="formEdit.activity_expenses">
            <a-radio-button :value="true">Yes</a-radio-button>
            <a-radio-button :value="false">No</a-radio-button>
          </a-radio-group>
        </a-col>
      </a-row>
      <a-card style="box-shadow:none" v-if="formEdit.activity_expenses">
        <a-row class="mt-10 mb-10">
          <a-col :span="6">
            <p class="text-center mt-5 mb-0 font-bold">
              <b>Budget (Activity Expense)</b>
            </p>
          </a-col>
        </a-row>
        <a-row class="mt-10 mb-10">
          <a-col :span="6">
            <p class="text-center mt-5 mb-0 font-bold">
              Actual Expense Details <span class="text-danger">*</span>
            </p>
          </a-col>
          <a-col :span="12">
            <a-textarea placeholder="" :rows="5" v-model="formEdit.actual_expense_detail" />
          </a-col>
        </a-row>
        <a-row class="mt-10 mb-10">
          <a-col :span="6">
            <p class="text-center mt-5 mb-0 font-bold">
              Grand Total <span class="text-danger">*</span>
            </p>
          </a-col>
          <a-col :span="12">
            <a-input v-model="formEdit.grand_total" />
          </a-col>
        </a-row>
        <a-row class="mt-10 mb-10">
          <a-col :span="6">
            <p class="text-center mt-5 mb-0 font-bold">
              Income <span class="text-danger">*</span>
            </p>
          </a-col>
          <a-col :span="12">
            <a-input v-model="formEdit.income" />
          </a-col>
        </a-row>
        <a-row class="mt-10 mb-10">
          <a-col :span="6">
            <p class="text-center mt-5 mb-0 font-bold">
              Profit <span class="text-danger">*</span>
            </p>
          </a-col>
          <a-col :span="12">
            <a-input v-model="formEdit.profit" />
          </a-col>
        </a-row>
      </a-card>

      <a-row class="mt-10 mb-10">
        <a-col :span="6">
          <p class="text-center mt-5 mb-0 font-bold">
            No. of Participants <span class="text-danger">*</span>
          </p>
        </a-col>
        <a-col :span="12">
          <a-input type="number" v-model="formEdit.no_of_participants" />
        </a-col>
      </a-row>


    </a-modal>
    <!-- <a-modal v-model="isShowModal" :closable="false" :maskClosable="false"> -->
    <component :is="currentModalComponent" :viewModal="isShowModal" :onShowModal="onShowModal"
      :onCloseModal="onCloseModal" :lengthDataTable="countObjData" :dataFilter="formSearch"></component>
    <!-- </a-modal> -->
  </div>
</template>

<script>
import exportActivityData from "./modal/ExportActivityData.vue";

const formSearchRaw = {
  searchText: ""
}
export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Array,
      default: () => [],
    },
    columns: {
      type: Array,
      default: () => [],
    },
    currentPage: {
      type: Number,
      default: () => 0,
    },
    countObjData: {
      type: Number,
      default: () => 0,
    },
    perPage: {
      type: Number,
      default: () => 0,
    },
    loadBtnExport: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formSearch: formSearchRaw,
      loadingEdit: false,
      formEdit: {},
      _haveExpense: false,
      visibleEdit: false,
      isShowModal: false,
      currentModalComponent: 'exportActivityData',
    };
  },
  methods: {
    onChangePage(current) {
      this.currentPage = current;
      this.offset = parseInt(current - 1) * parseInt(this.perPage);
      this.$emit("changepage", {
        currentPage: this.currentPage,
        offset: this.offset,
      });
    },
    toCreateData() {
      this.$router
        .push({
          path: "/activity/form",
        })
        .catch((err) => { });
    },
    onSearchData() {
      this.$emit("search", {
        dataQuery: this.formSearch,
      });
    },
    // update
    onModalEdit(val) {
      this.loadingEdit = false;
      this.formEdit = Object.assign({}, val);
      //console.log(this.formEdit)
      this.visibleEdit = !this.visibleEdit;
    },
    onShowModal(modal) {
      this.isShowModal = true;
      this.currentModalComponent = modal
    },
    onCloseModal() {
      this.isShowModal = false;
    },
    // 
    async onChangeDataActivity() {
      this.loadingEdit = true;
      this.formEdit.date_of_activity = this.moment(this.formEdit.date_of_activity).format("YYYY-MM-DD")
      // api patch
      return new Promise((resolve) => {
        this.$http
          .patch(
            "/student_affair/alumni-activity/" + this.formEdit.id + "/",
            this.formEdit
          )
          .then((response) => {
            if (response.status) {
              this.$emit("updateObjMainActivity", { data: response.data });
              this.onModalEdit({});
              this.loadingEdit = false;
              this.$notification['success']({
                message: function (h) {
                  return h("div", [
                    h("strong", { class: "" }, `Updated data successfully`),
                  ]);
                },
              });
              resolve(true);
            }
          })
          .catch((error) => {
            this.$notification['error']({
              message: function (h) {
                return h("div", [
                  h("strong", { class: "" }, `Failed to connect to the API`),
                ]);
              },
              description:
                `Error ${error.response.status} : /student_affair/alumni-activity/`,
            });
            this.loadingEdit = false;
            resolve(false);
          });
      });
    },
  },
  components: {
    exportActivityData
  }
};
</script>